import { render, staticRenderFns } from "./detail-team.vue?vue&type=template&id=df55d9aa&scoped=true&"
import script from "./detail-team.vue?vue&type=script&lang=js&"
export * from "./detail-team.vue?vue&type=script&lang=js&"
import style0 from "./detail-team.vue?vue&type=style&index=0&id=df55d9aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df55d9aa",
  null
  
)

export default component.exports